<template>
  <div v-if="showTag">
    <div class="mask fixed t0 b0 r0 l0" @click="hide" style="z-index: 100"></div>
    <div class="main fixed b0 r0 l0 bg_white flex overflow-x-hidden overflow-y-auto" :class="['level'+level]"
         style="z-index: 200">
      <template v-if="level==1">
        <ul class="flex1">
          <li v-for="(item,index) in data" :key="index" class="pt15 pb15 fs16 flex flex-center-2"
              :class="[{bt:index>0}]"
              @click="handler(item)">
            <div class="relative">{{item.label}}
              <div class="desc absolute fs12 t0 b0 flex flex-center" v-if="item.desc">{{item.desc}}</div>
            </div>
          </li>
        </ul>
      </template>
      <template v-if="level==2">
        <ul class="flex0 overflow-y-auto">
          <li @click="curr=index" v-for="(item,index) in data" :key="index" class="pt15 pb15 center fs16"
              :class="[{bt:index>0},index==curr?'color_main':'']">
            {{item.label}}
          </li>
        </ul>
        <ul class="flex1 overflow-y-auto">
          <li v-for="(item,index) in sons" :key="index" class="pt15 pb15 center fs16"
              :class="[{bt:index>0}]"
              @click="handler(item)">
            {{item.label}}
          </li>
        </ul>
      </template>
    </div>
  </div>
</template>

<script>
  /**
   *
   * events
   * popupClose
   */
  export default {
    name: "v-popup",
    data() {
      return {
        data: [],
        curr: 0,
        model: "",
        level: 1,
        showTag: false
      }
    },

    computed: {
      sons() {
        let {data, curr} = this,
          currData = data.length > 0 ? data[curr] : {},
          sons = currData.children && currData.children.length > 0 ? currData.children : [currData];
        return sons.map(r => {
          r.label = r.label === '全部' ? '全部' + currData.label : r.label;
          return r;
        });
      }
    },

    created() {
      bus.$on("popup", (data) => {
        if (data === false) this.showTag = false;
        else {
          this.level = data.level;
          this.data = data.data;
          this.model = data.model;
          this.showTag = true;
        }
      })
    },

    methods: {
      hide() {
        this.showTag = false;
      },
      handler(data) {
        bus.$emit('popupClose', {
          data,
          model: this.model
        });
        this.hide();
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "../common/public";

  .mask {
    background-color: rgba(0, 0, 0, .5);
  }

  .main {
    max-height: 70%;
  }

  .desc {
    color: #D0021B;
    left: 105%;
    width: 150%;

  }

  ul.flex0 {
    width: px2rem(175px);
  }

  .level2::after {
    content: '';
    display: block;
    position: absolute;
    left: px2rem(175px);
    top: 0;
    bottom: 0;
    border-left: 0.5px solid $borderColor;
  }
</style>



// WEBPACK FOOTER //
// src/plugins/v-popup.vue